import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import {
  COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_BEGIN,
  COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_SUCCESS,
  COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_FAILURE,
  COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_DISMISS_ERROR,
} from './constants';

export function extractFieldsFromPrompt(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_AI_ENGINE}v${version}/generate-collection/prompt`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            collectionName: res.data.collectionName,
          });
          toast.success('Collection Extracted Successfully !');
          resolve(res);
        },
        (err) => {
          toast.error(`Failed: ${err.response.data.error}`, {});
          Mixpanel.track('Failed to extract collection');
          dispatch({
            type: COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_FAILURE,
            data: { error: `Failed` },
          });
          console.log('createWithPrompt error', err.response);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExtractFieldsFromPromptError() {
  return {
    type: COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_BEGIN:
      return {
        ...state,
        extractFieldsFromPromptPending: true,
        extractFieldsFromPromptError: null,
      };

    case COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_SUCCESS:
      return {
        ...state,
        extractFieldsFromPromptPending: false,
        extractFieldsFromPromptError: null,
        promptItems: action.data.fields.flat(),
      };

    case COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_FAILURE:
      return {
        ...state,
        extractFieldsFromPromptPending: false,
        extractFieldsFromPromptError: action.data.error,
      };

    case COLLECTIONS_EXTRACT_FIELDS_FROM_PROMPT_DISMISS_ERROR:
      return {
        ...state,
        extractFieldsFromPromptError: null,
      };

    default:
      return state;
  }
}